/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { HeaderTitle } from '../ui/services/HeaderTitle';
import { HeaderDescription } from '../ui/services/HeaderDescription';
import { getServicesPage } from '@/sanity/client';
import { useSiteSettings } from '@/hooks/useSiteSettings';
import { cn } from '@/lib/utils';

import BackgroundImageContainer from '../ui/BackgroundImageContainer';

const ServicesHeader: React.FC = () => {
	const [headerData, setHeaderData] = useState<any>(null);
	const [loading, setLoading] = useState(true);
	const { isBannerActive } = useSiteSettings();

	useEffect(() => {
		const fetchHeaderData = async () => {
			try {
				const pageData = await getServicesPage();
				if (pageData?.header) {
					setHeaderData(pageData.header);
				}
			} catch (error) {
				console.error('Error fetching services page data:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchHeaderData();
	}, []);

	// Background image URL - use CMS data if available, otherwise fallback
	const backgroundImageUrl = headerData?.backgroundImage
		? headerData.backgroundImage
		: '/contact-banner.svg';

	// Overlay opacity - use CMS data if available, otherwise fallback to 50%
	const overlayOpacity =
		headerData?.overlayOpacity !== undefined
			? headerData.overlayOpacity / 100
			: 0.5;

	return (
		<section className=''>
			<BackgroundImageContainer
				imageUrl={backgroundImageUrl}
				overlayOpacity={overlayOpacity}
				className={cn(
					'flex flex-col items-center px-5 w-full md:px-10 max-md:max-w-full',
					isBannerActive ? 'pt-24' : 'pt-20',
				)}
			>
				<div className='mb-0 w-full max-w-[1215px] max-md:mb-2.5 max-md:max-w-full'>
					<div className='flex gap-5 max-md:flex-col py-4 md:px-10 px-5'>
						<div className=' w-full max-md:ml-0 max-md:w-full py-8'>
							<div className='mr-0 font-bold text-neutral-100 max-md:max-w-full'>
								{/* Pass CMS data to components */}
								<HeaderTitle title={headerData?.title} />
								<HeaderDescription
									description={headerData?.description}
									subtitle={headerData?.subtitle}
								/>
							</div>
						</div>
					</div>
				</div>
			</BackgroundImageContainer>
		</section>
	);
};

export default ServicesHeader;
